import React from 'react';
import { useParams } from 'react-router-dom';
import CreateSubcontractingReport from './CreateSubcontractingReport';

const EditSubcontractingReport = () => {
  const { id } = useParams();

  return (
    <CreateSubcontractingReport
      editMode={true}
      reportId={id}
    />
  );
};

export default EditSubcontractingReport;
